function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:none;}.b{fill:#636363;}"));

var _ref3 = /*#__PURE__*/React.createElement("g", {
  transform: "translate(-1164 -38)"
}, /*#__PURE__*/React.createElement("rect", {
  className: "a",
  width: 25,
  height: 25,
  transform: "translate(1164 38)"
}), /*#__PURE__*/React.createElement("g", {
  transform: "translate(1164.999 39)"
}, /*#__PURE__*/React.createElement("path", {
  className: "b",
  d: "M0,18.863H8.065V21.6H5.377V22.94H17.519V21.6H14.83V18.863h8.11V0H0ZM13.486,21.6H9.409V18.863h4.077ZM1.344,17.519V14.786H21.6v2.733ZM21.6,1.344v12.1H1.344V1.344Zm0,0"
}), /*#__PURE__*/React.createElement("path", {
  className: "b",
  d: "M249.913,60H240v4.208h9.913Zm-1.4,2.806H241.4V61.4h7.107Zm0,0",
  transform: "translate(-229.778 -57.194)"
}), /*#__PURE__*/React.createElement("path", {
  className: "b",
  d: "M249.913,180H240v4.208h9.913Zm-1.4,2.806H241.4v-1.4h7.107Zm0,0",
  transform: "translate(-229.778 -172.01)"
}), /*#__PURE__*/React.createElement("path", {
  className: "b",
  d: "M94.208,62.1a2.1,2.1,0,1,0-2.1,2.1A2.107,2.107,0,0,0,94.208,62.1Zm-2.1.7a.7.7,0,1,1,.7-.7A.7.7,0,0,1,92.1,62.806Zm0,0",
  transform: "translate(-86.005 -57.194)"
}), /*#__PURE__*/React.createElement("path", {
  className: "b",
  d: "M67.014,153.507a3.507,3.507,0,0,0-7.014,0v2.1h7.014Zm-1.4.7H61.4v-.7a2.1,2.1,0,0,1,4.208,0Zm0,0",
  transform: "translate(-57.194 -143.369)"
})));

var SvgIcAdmin = function SvgIcAdmin(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgIcAdmin, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/ic_admin.3727a485.svg";
export { ForwardRef as ReactComponent };